import { createSlice } from "@reduxjs/toolkit";
import { businessInfo } from "./thunk";
export const initialState = {
    businessInfo: {
        // business_type: '',
        // business_logo: '',
        // vendor_id:'2'
  },
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const businessInfoSlice = createSlice({
  name: "businessInfo",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
      updateBusinessInfo(state, action) {
        if (action.payload.business_type) {
          state.businessInfo.business_type = action.payload.business_type
        }
        if (action.payload.gst_in) {
          state.businessInfo.gst_in = action.payload.gst_in
        }
    //   state.businessInfo = action.payload
      state.loading = false;
      state.errorMsg = false;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(businessInfo.pending, (state) => {
        state.loading = true;
        state.errorMsg = null;
      })
      .addCase(businessInfo.fulfilled, (state, action) => {
        // console.log('fullFilleed',action);
        if (action.payload.business_type) {
          state.businessInfo.business_type = action.payload.business_type
        }
        if (action.payload.gst_in) {
          state.businessInfo.gst_in = action.payload.gst_in
        }
        state.businessInfo = action.payload
        state.loading = false;
        state.errorMsg = false;
      })
      .addCase(businessInfo.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
        state.errorMsg = true;
      });
  }
});

export const {
  updateBusinessInfo
} = businessInfoSlice.actions

export default businessInfoSlice.reducer;